// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"3185":"c70f55145571350c","8778":"869129ed096e5468"}[chunkId] + ".css";
};